import {
  StyleBannerCard,
  StyleLeftBannerWrapper,
  StyleRightBannerWrapper,
} from './style'
import Image from '@components/image'
import BannerImg from './banner.png'
import Typography from '@components/typography'
const Banner = () => {
  return (
    <StyleBannerCard>
      <StyleLeftBannerWrapper>
        <Typography
          content="Upload Document to Ge Verified!"
          size={24}
          tc="primary"
        />
        <Typography
          content="“Without Verification Patients can’t reach you.”"
          size={20}
          tc="text"
        />
      </StyleLeftBannerWrapper>
      <StyleRightBannerWrapper>
        <Image src={BannerImg} />
      </StyleRightBannerWrapper>
    </StyleBannerCard>
  )
}

export default Banner
